import { notify } from "hooks/use-notification/useNotification"

export type fileProcessorType = 'file' | 'stream' | 'string'
export type validExtension = 'csv' | 'pdf' | 'jpg' | 'png' | 'jpeg' | 'doc' | 'docx' | 'xls' | 'xlsx' | string[]

const processFile = (file: any, processType: fileProcessorType, callback?: (params: any) => void) => {
  if (processType === 'file') {
    return file
  }
  if (processType === 'stream') {
    const fileReader = new FileReader()
    fileReader.onload = () => {
      const result = fileReader.result
      if (callback) {
        callback({ file: result, fileName: file.name })
      }
      return { file: result, fileName: file.name }
    }
    fileReader.readAsDataURL(file)
  }
  if (processType === 'string') {
    const fileReader = new FileReader()
    fileReader.onload = () => {
      const result = fileReader.result as string
      if (callback) {
        callback({ file: result, fileName: file.name })
      }
      return { file: result, fileName: file.name }
    }
    fileReader.readAsText(file)
  }
}

export const getProcessedFile = (
  files: any,
  extension: validExtension | validExtension[],
  processType: fileProcessorType,
  callback?: (params: any) => void
) => {
  if (files?.length > 1) {
    notify('error', 'Only one file at a time')
    return
  }
  if (files?.length === 0) {
    return
  }
  const file = files[0]
  const fileNameArray = file?.name?.toLowerCase()?.split('.')

  if (Array.isArray(extension)) {
    if (!extension.includes(fileNameArray[fileNameArray?.length - 1])) {
      notify('error', `Invalid file types ${extension.join('/')}`)
      return
    }
  } else {
    if (fileNameArray[fileNameArray.length - 1] !== extension) {
      notify('error', `Invalid file type: ${extension}`)
      return
    }
  }

  const result = processFile(file, processType, callback)
  return result
}

export const useFileUpload = () => {
  return {
    getProcessedFile
  } as const
}
